// import feathers from '@feathersjs/feathers'
import feathers from '@feathersjs/client'
// import socketio from '@feathersjs/socketio-client'
// import auth from '@feathersjs/authentication-client'
// import rx from 'feathers-reactive'
// import memory from 'feathers-memory'
// import reactive from 'feathers-reactive'
// import io from 'socket.io-client'
// import RxJS from 'rxjs'
import { FEATHERS_HOST } from './config'

// const feathers_host = process.env.NODE_ENV === 'development' ? 'http://localhost:3030' : 'http://34.208.116.16:3030'

// const socket = io('http://localhost:3030')
// const app = feathers()

// app.configure(socketio(socket))
// app.configure(rx({ idField: '_id' }))

// app.service('messages')
//   .on('created', message => console.log('New message created', message))

// app.service('messages').create({
//   text: 'A message from a REST client'
// })

// export default app

const app = feathers()

app.configure(feathers.rest(FEATHERS_HOST).fetch(window.fetch));

const authService = feathers.authentication({
  storage: window.localStorage,
  storageKey: 'accessToken'
})
app.configure(authService)

export default app



// WEBPACK FOOTER //
// ./src/feathers.js